
import { AdminKeys } from '@/i18n/types/admin.types';

export const admin: Record<AdminKeys, string> = {
  adminPanel: 'Admin Panel',
  productManagement: 'Product Management',
  createProduct: 'Create Product',
  editProduct: 'Edit Product',
  deleteProduct: 'Delete Product',
  productName: 'Product Name',
  productDescription: 'Product Description',
  productPrice: 'Price',
  productCurrency: 'Currency',
  productImage: 'Product Image',
  isActive: 'Is Active',
  uploadImage: 'Upload Image',
  removeImage: 'Remove Image',
  saveProduct: 'Save Product',
  cancelEdit: 'Cancel',
  confirmDelete: 'Confirm Delete',
  deleteConfirmMessage: 'Are you sure you want to delete this product? This action cannot be undone.',
  productCreated: 'Product created successfully',
  productUpdated: 'Product updated successfully',
  productDeleted: 'Product deleted successfully',
  errorCreatingProduct: 'Error creating product',
  errorUpdatingProduct: 'Error updating product',
  errorDeletingProduct: 'Error deleting product',
  errorUploadingImage: 'Error uploading image',
  requiredField: 'This field is required',
  invalidPrice: 'Please enter a valid price',
  adminAccessRequired: 'Administrator access required',
  loadingProducts: 'Loading products...',
  noProductsFound: 'No products found',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  active: 'Active',
  inactive: 'Inactive',
  dragImageHere: 'Drag image here',
  orClickToSelect: 'or click to select',
  imageUploaded: 'Image uploaded successfully',
  maxFileSize: 'Maximum file size: 5MB',
  allowedFormats: 'Allowed formats: JPG, PNG, WebP',
  administration: 'Administration',
  adminProducts: 'Admin: Products',
  adminFeatures: 'Admin: Features',
};
